export const SESSION_KEY = 'session-key';
